<style scoped lang="scss">

</style>

<template>
    <div>
        <div ref="notice-modal" id="notice-modal" esc-close="false" class="uk-modal">
            <div class="uk-modal-dialog uk-modal-dialog-blank">
                <button class="uk-modal-close uk-close" type="button"></button>
                <div id="pre-qualify-box" class="uk-grid uk-flex-middle">
                    <div class="uk-width-1-6 uk-width-medium-1-3 uk-height-viewport uk-cover-background uk-row-first " style="background-image: url('/images/home-top-bg-mobile.jpg');"></div>
                    <div class="uk-width-5-6 uk-width-medium-2-3 uk-height-1-1 uk-overflow-container">
                        <div class="uk-width-9-10 uk-align-center uk-margin-small-top uk-vertical-align-middle">
                            <p class="uk-visible-small"><br />
                            </p>
                            <h2 class="uk-text-center">Everyone must be prequalified before applying.</h2>
                            <a id="pre-qualify-form-button" href="javascript:;" @click="showFormModal" class="uk-button uk-button-primary uk-button-large uk-width-9-10 uk-width-small-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center uk-animation-fade" ><i class="uk-icon-pencil-square-o"></i> Click Here to Prequalify</a>
                            <hr />
                            <a href="#document-check-list" data-uk-modal class="uk-button uk-button-secondary uk-button uk-width-9-10 uk-width-small-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center uk-animation-fade" ><i class="uk-icon-check-square-o"></i> Documentation Checklist</a>
                            <p class="uk-animation-fade uk-width-9-10"><small class="uk-text-center">Please be prepared to upload copies of your documents in the Pre-Application Checklist. It is important to check the legibility of your photos and/or scans otherwise it can delay your application. To process your application you must have an active email account or access to text messages to receive notifications (provider text and data fees may apply).</small> <small>Funds are not guaranteed.</small></p>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="pre-qualify-form" id="pre-qualify-form-vue" class="uk-modal" uk-modal="{bgClose:false, 'esc-close': false, keyboard: false}">
            <div class="uk-modal-dialog uk-modal-dialog-blank">
                <div class="uk-grid uk-flex-middle">
                    <div class="uk-width-1-10 uk-height-viewport"> &nbsp;</div>
                    <div v-if="showDeclined" class="uk-width-8-10 uk-width-medium-5-10 ">
                        <div class="uk-grid uk-text-center">
                            <div class="uk-width-1-1 ">
                                <div class="uk-width-9-10 uk-align-center uk-margin-small-top">
                                    <p class="uk-visible-small"><br/>
                                    </p>
                                    <h2 class="uk-width-1-1 uk-align-center uk-animation-fade uk-margin-small-top">We're sorry, but
                                        you do not qualify for the The {{ program.program_name}} program.</h2>
                                    <hr/>
                                    <div id="not-qualified-note" class="uk-width-9-10 uk-align-center"></div>
                                    <p class="uk-animation-fade uk-width-9-10">Based on the answer(s) you have provided in the
                                        prequalification questionnaire, unfortunately you do not qualify for our program.</p>
                                    <h3 class="uk-width-small-1-1 uk-margin-bottom">Help, I don't qualify</h3>
                                    <p class="uk-animation-fade uk-width-9-10">
                                        If you feel you reached this in error, please <span v-if="env.PUBLIC_EMAIL">email at <a :href="'mailto:' + env.PUBLIC_EMAIL">{{ env.PUBLIC_EMAIL }} </a></span><span v-if="env.PUBLIC_EMAIL && env.PUBLIC_PHONE">or </span><span v-if="env.PUBLIC_PHONE">call us at <a :href="'tel:' + env.PUBLIC_EMAIL">{{ env.PUBLIC_PHONE }}</a></span>
                                    </p>
                                </div>

                                <div class="uk-width-1-1 uk-text-center">
                                    <button class="uk-button uk-button-primary" @click="setDisqualified">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="field-partner-questions" v-else-if="showFieldPartnerForm"
                         class="uk-width-9-10 uk-width-medium-5-10">
                        <div class="uk-width-8-10">
                            <div class="uk-text-center">
                                <h2>Are you working with a Community Partner/Agency/Organization?</h2>
                                <div class="uk-width-9-10 uk-align-center" v-if="usingFieldPartner === null">
                                    <a
                                            @click="setUsingFieldPartner(true)"
                                            class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade">
                                        <i class="uk-icon-square-o"></i> Yes</a>
                                    <a
                                            @click="setUsingFieldPartner(false)"
                                            class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"><i
                                            class="uk-icon-square-o"></i> No</a>
                                </div>

                                <div class="uk-grid uk-text-left" v-else>

                                    <div class="uk-width-1-1 uk-margin-bottom">
                                        <validated-section :errors="errors" field="pid">
                                            <label>Community Partner ID</label>
                                            <input type="text" class="uk-form-large uk-width-1-1"
                                                   placeholder="Community Partner ID" v-model="fieldPartnerId">
                                        </validated-section>
                                    </div>

                                    <div class="uk-width-small-1-1 uk-width-medium-1-2">
                                        <button @click="checkFieldPartnerId()" :disabled="fieldPartnerLoading"
                                                class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 ">
                                            <span v-if="fieldPartnerLoading">Checking ID...</span>
                                            <span v-else>Verify ID and Continue</span>
                                        </button>
                                    </div>
                                    <div class="uk-width-small-1-1 uk-width-medium-1-2">
                                        <button @click="setUsingFieldPartner(false)"
                                                class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1">
                                            Continute without Community Based Organization
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="pre-qual-questions" class="uk-width-8-10 uk-width-medium-5-10 " v-else>
                        <a name="questions-top"></a>
                        <div v-for="question in program.prequalification_questions"
                             v-show="currentQuestion == question.number" class="uk-width-9-10 uk-align-center">
                            <p class="uk-visible-small"><br/></p>
                            <h2 class="uk-text-center">Question {{ question.number }}:</h2>
                            <div v-if="question.type === 'income'">
                                <income-question :states="states" :counties="counties" :program="program" @addressVerified="updateVerifiedAddress"></income-question>
                            </div>



                            <div v-else class="uk-text-center" v-html="question.body"></div>
                            <hr/>
                            <div class="uk-width-9-10 uk-align-center" v-if="question.type !== 'income' || question.type !== 'partner' || verifiedAddress !== null">
                                <a class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"
                                   @click="answerQuestion(question.number,'yes');">
                                    <i class="uk-icon-square-o"></i> Yes</a>
                                <a class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"
                                   @click="answerQuestion(question.number,'no');"><i class="uk-icon-square-o"></i> No</a>
                            </div>
                        </div>

                        <div v-if="showForm && !application">
                            <p class="uk-visible-small"><br/></p>
                            <h2 class="uk-text-left">Congratulations!</h2>
                            <p class="uk-text-left">Based on your answers, you have been prequalified. Please note that
                                prequalifying does not guarantee approval for funding.</p>

                            <hr/>
                            <!-- DEV NOTE: be careful to include all the question-X where x is the question number -->
                            <form autocomplete="off" class="uk-form uk-width-1-1 uk-align-center uk-grid" id="question-9-ssns" name="question-9-ssns" onsubmit="return false;">
                                <input type="hidden" name="program_slug" :value="program.slug"/>

                                <p class="uk-margin-bottom">You must complete the remaining sections of this application.
                                    Failure to complete this application and provide the required documentation will
                                    prevent your application from consideration under the {{ program.program_abbreviation }} program. It is important
                                    to complete your application as soon as possible. Please enter the Head of Household's
                                    registration information, and then the names and {{ ssnPlaceHolder.toLowerCase() }}s of each
                                    household member 18 years or over.</p>

                                <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-padding-remove">
                                    <h3>*Head of Household (HH):</h3>
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-padding-remove">
                                    <div class="uk-grid">
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <label>First Name *</label>
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="first_name">
                                                <input v-model="form.hoh.first_name" class="uk-width-1-1 uk-form-large" type="text"
                                                       placeholder="HH's First Name(*)" required>
                                            </validated-section>
                                        </div>
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="last_name">
                                                <label>Last Name *</label>
                                                <input v-model="form.hoh.last_name" class="uk-form-large uk-width-1-1" type="text"
                                                       placeholder="HH's Last Name(*)"  required>
                                            </validated-section>
                                        </div>
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="email">
                                                <label>Email *</label>
                                                <input v-model="form.hoh.email" class="uk-form-large uk-width-1-1" type="text"
                                                       @change="checkForDuplicateEmailAddress(form.hoh.email)"
                                                       placeholder="HH's Email (*)"  required>
                                            </validated-section>
                                        </div>
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="email_confirmation">
                                                <label>Confirm Email *</label>
                                                <input v-model="form.hoh.email_confirmation" class="uk-form-large uk-width-1-1" type="text"
                                                       placeholder="Confirm HH's Email (*)"  required>
                                            </validated-section>
                                        </div>
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="phone_number">
                                                <label>Phone Number *</label>
                                                <input v-model="form.hoh.phone" v-mask="'(###) ###-####'" class="uk-form-large uk-width-1-1" type="text"
                                                       placeholder="HH's Phone Number (*)"  required>
                                            </validated-section>
                                        </div>

                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="phone_confirmation">
                                                <label>Phone Number *</label>
                                                <input v-model="form.hoh.phone_confirmation" v-mask="'(###) ###-####'" class="uk-form-large uk-width-1-1" type="text"
                                                       placeholder="Confirm HH's Phone Number (*)"  required>
                                            </validated-section>
                                        </div>

                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="password">
                                                <label>Password *</label>
                                                <input v-model="form.hoh.password" class=" uk-form-large uk-width-1-1 uk-margin-small-bottom"
                                                       type="password" placeholder="Password(*)" name="question-9-password-1" required>
                                                <div class="uk-text-danger">{{ getPasswordFieldMessage('password')}}</div>
                                            </validated-section>
                                        </div>
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="password_confirmation">
                                            <label>Confirm Password *</label>
                                            <input v-model="form.hoh.password_confirmation" class=" uk-form-large uk-width-1-1 uk-margin-small-bottom"
                                                   type="password" placeholder="Confirm Password(*)"
                                                   required>
                                                <div class="uk-text-danger">{{ getPasswordFieldMessage('password_confirmation')}}</div>
                                             </validated-section>
                                        </div>
                                        <div v-if="program.settings['show-ssn-registration']" class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="ssn">
                                                <label v-html="ssnLabel"></label>
                                                <input v-model="form.hoh.ssn" @change="checkForDuplicateSocialSecurityNumber(form.hoh.ssn)"  v-mask="'###-##-####'" class="uk-width-1-1 uk-form-large uk-margin-small-bottom"
                                                       type="text" :placeholder="ssnPlaceHolder" >
                                            </validated-section>
                                        </div>
                                        <div v-if="program.settings['show-ssn-registration']" class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="ssn_confirmation">
                                                <label v-html="`Confirm ${ssnLabel}`"></label>
                                                <input v-model="form.hoh.ssn_confirmation" v-mask="'###-##-####'" class="uk-width-1-1 uk-form-large uk-margin-small-bottom" type="text" :placeholder="`Confirm ${ssnPlaceHolder}`" >
                                            </validated-section>
                                        </div>

                                    </div>
                                </div>

                                <div v-if="program.settings['show-hhms-registration']" v-for="(member, i) in householdMembers"
                                     class="uk-width-1-1 uk-grid uk-grid-collapse uk-padding-remove household-member-wrapper">
                                    <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-margin-top uk-padding-remove">
                                        <h3>Household Member {{ i+2 }}:</h3>
                                        <div><a href="#" @click="removeMember(i)">Remove</a></div>
                                    </div>
                                    <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-padding-remove">
                                        <div class="uk-grid">
                                            <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                                <validated-section class="uk-width-1-1" :errors="errors" :field="'hh_data.'+i+'.first_name'">
                                                    <label for="">Household Member #{{ i+2 }} First Name <span>*</span></label>
                                                    <input v-model="member.first_name" class="uk-form-large uk-width-1-1" type="text" placeholder="First Name" required>
                                                </validated-section>
                                            </div>
                                            <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                                <validated-section class="uk-width-1-1" :errors="errors" :field="'hh_data.'+i+'.last_name'">
                                                    <label for="">Household Member #{{ i+2 }} Last Name <span>*</span></label>
                                                    <input v-model="member.last_name"  class="uk-form-large uk-width-1-1" type="text" placeholder="Last Name" required>
                                                </validated-section>
                                            </div>
                                            <validated-section class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom" :errors="errors" :field="'hh_data.'+i+'.ssn'">
                                                <label v-html="`Household Member # ${i+2} ${ssnLabel}`"></label>
                                                <input v-model="member.ssn" v-mask="'###-##-####'" @change="checkForDuplicateSocialSecurityNumber(member.ssn, i)"  class="uk-form-large uk-width-1-1" type="text" :placeholder="ssnPlaceHolder">
                                            </validated-section>

                                            <div class="uk-width-1-1 uk-width-medium-1-2">
                                                <input type="checkbox" class="uk-margin-top " checked="true"> Is at Least 18 & Has Income<span>*</span>
                                            </div>
                                        </div>

                                    </div>

                                    <hr class="uk-width-1-1 uk-margin-small uk-margin-bottom" :class="'hh-member-hr-'+i"/>
                                </div>

                                <div  v-if="program.settings['show-hhms-registration']" class="uk-width-1-1 uk-padding-remove">
                                    <a id="add-member-1" class="uk-button uk-button-mini uk-margin-bottom uk-width-1-1"
                                       @click="addHouseholdMember">
                                        ADD HOUSEHOLD MEMBER {{ this.householdMembers.length + 2 }}</a>
                                </div>

                                <div class=" uk-width-1-1 uk-align-center uk-margin-top uk-padding-remove">
                                    <button class="uk-button uk-button-large uk-width-small-1-1 uk-width-medium-9-10 uk-margin-bottom uk-align-center uk-animation-fade"
                                            type="button" @click="submit">
                                        <i class="uk-icon-check-square-o"></i> REGISTER</a></button>
                                </div>


                            </form>
                        </div>

                        <div v-if="showForm && application">
                            <h2 class="uk-text-left">Congratulations!</h2>
                            <p class="uk-text-left">
                                Based on your answers, you have been prequalified. Please note that
                                prequalifying does not guarantee approval for funding.
                            </p>

                            <p class="uk-margin-bottom">You must complete the remaining sections of this application.
                                Failure to complete this application and provide the required documentation will
                                prevent your application from consideration under the {{ program.program_abbreviation }} program. It is important
                                to complete your application as soon as possible. Please enter the Head of Household's
                                registration information, and then the names and {{ ssnPlaceHolder.toLowerCase() }}s of each
                                household member 18 years or over.
                            </p>

                            <h3>Please create a password and enter your {{ ssnPlaceHolder }} to continue.</h3>

                            <div class="uk-grid">
                                <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom">
                                    <div class="uk-grid">
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="password">
                                                <label>Password *</label>
                                                <input v-model="form.hoh.password" class=" uk-form-large uk-width-1-1 uk-margin-small-bottom"
                                                       type="password" placeholder="Password(*)" name="question-9-password-1" required>
                                                <div class="uk-text-danger">{{ getPasswordFieldMessage('password')}}</div>
                                            </validated-section>
                                        </div>
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="password_confirmation">
                                                <label>Confirm Password *</label>
                                                <input v-model="form.hoh.password_confirmation" class=" uk-form-large uk-width-1-1 uk-margin-small-bottom"
                                                       type="password" placeholder="Confirm Password(*)"
                                                       required>
                                                <div class="uk-text-danger">{{ getPasswordFieldMessage('password_confirmation')}}</div>
                                            </validated-section>
                                        </div>
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="ssn">
                                                <label v-html="ssnLabel"></label>
                                                <input v-model="form.hoh.ssn" @change="checkForDuplicateSocialSecurityNumber(form.hoh.ssn)" v-mask="'###-##-####'" class="uk-width-1-1 uk-form-large uk-margin-small-bottom"
                                                       type="text" :placeholder="ssnPlaceHolder" >
                                            </validated-section>
                                        </div>
                                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                                            <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="ssn_confirmation">
                                                <label v-html="`Confirm ${ssnLabel}`"></label>
                                                <input v-model="form.hoh.ssn_confirmation" v-mask="'###-##-####'" class="uk-width-1-1 uk-form-large uk-margin-small-bottom" type="text" :placeholder="`Confirm ${ssnPlaceHolder}`" >
                                            </validated-section>
                                        </div>

                                        <div class=" uk-width-1-1 uk-align-center uk-margin-top uk-padding-remove">
                                            <button class="uk-button uk-button-large uk-width-small-1-1 uk-width-medium-9-10 uk-margin-bottom uk-align-center uk-animation-fade"
                                                    type="button" @click="submitForApplication">
                                                <i class="uk-icon-check-square-o"></i> CONTINUE TO MY APPLICATION</a></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="uk-grid" v-if="!application">
                            <div class="uk-width-9-10 uk-align-center">
                                <hr>
                                <br/><a
                                    class="uk-button uk-button-small  uk-width-small-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center uk-animation-fade"
                                    @click="cancel"><i class="uk-icon-times-circle"></i> CANCEL PREQUALIFICATION</a>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-10">&nbsp;</div>


                    <div id="prequal-list"
                         class="uk-width-medium-3-10 uk-cover-background uk-row-first uk-overflow-container uk-height-viewport">
                        <div class="uk-width-9-10 uk-align-center uk-margin-top">
                            <a name="Answers"></a>
                            <h3 class="uk-contrast" align="center">Prequalification Statements</h3>
                            <hr/>
                            <!-- these are the outputs for each prequalification question -->
                            <div v-for="question in program.prequalification_questions" class="uk-contrast uk-grid"
                                 v-show="answers[question.number] !== undefined">
                                <div class="uk-width-2-6 uk-margin-bottom"><i class="uk-icon-check-square-o"> </i>
                                    {{ question.number }}<br/><small><a @click="editQuestion(question.number)"
                                                                        href="#questions-top">CHANGE</a></small></div>
                                <div class="uk-width-4-6 uk-margin-bottom"><span v-html="question.statement"></span>
                                </div>
                                <div class="uk-width-1-1">
                                    <hr/>
                                </div>
                            </div>
                            <hr/>
                            <div class="uk-alert uk-width-7-10 uk-align-center">NOTE: Knowingly submitting incorrect answers
                                to prequalify constitutes fraud, and may be prosecuted to the fullest extent of the law.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <vk-modal :show="showChangeModal" v-if="changeQuestion" stack>
            <h3>CHANGE ANSWER:</h3>
            <label>QUESTION:</label>
            <div>
                <div v-if="changeQuestion.type === 'income'">
                    <income-question :states="states" :counties="counties" :program="program" @addressVerified="updateVerifiedAddress"></income-question>
                </div>
                <div v-else class="uk-text-center" v-html="changeQuestion.body"></div>
            </div>
            <div class="uk-width-9-10 uk-align-center" v-if="changeQuestion.type !== 'income' || verifiedAddress !== null">
                <a class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"
                   @click="answerQuestion(changeQuestion.number,'yes');">
                    <i class="uk-icon-square-o"></i> Yes</a>
                <a class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"
                   @click="answerQuestion(changeQuestion.number,'no');"><i class="uk-icon-square-o"></i> No</a>
            </div>
        </vk-modal>
    </div>

</template>

<script>
    import IncomeQuestion from "./IncomeQuestion";
    import ValidatedSection from "../../Common/ValidatedSection";
    import {mapState} from "vuex";
    import EventBus from "../../../../dashboard/EventBus";

    export default {
        name: "PrequalificationForm",
        components: {ValidatedSection, IncomeQuestion},
        props: ['program', 'states', 'counties', 'googleApiKey'],
        data() {
            return {
                application: null,
                showChangeModal: false,
                usingFieldPartner: null,
                fieldPartnerId: null,
                fieldPartnerConfirmed: false,
                fieldPartnerLoading: false,
                noticeModal: null,
                modal: null,
                declineModal: null,
                changeQuestionId: null,
                currentQuestion: 1,
                // answers: {1: 1, 2:2, 3:3, 4:4, 5:5, 6:6 }, // Dev
                answers: {},
                errors: {},
                formResponse: {},
                showDeclined: false,
                verifiedAddress: null,
                form: {
                    hoh: {
                        index: 1,
                        first_name: '',
                        last_name: '',
                        email: '',
                        email_confirmation: '',
                        password: '',
                        password_confirmation: '',
                        phone: '',
                        phone_confirmation: '',
                        ssn: '',
                        ssn_confirmation: '',
                    }
                },
                householdMembers: [],
            }
        },
        computed: {
            currentQuestionObject() {
                for(var i in this.program.prequalification_questions) {
                    if(this.program.prequalification_questions[i].number === this.currentQuestion) {
                        return this.program.prequalification_questions[i];
                    }
                }
                return null;
            },
            showFieldPartnerForm() {
                let currentQuestionObject = this.currentQuestionObject;
                return currentQuestionObject && currentQuestionObject.type === 'partner';
            },
            ssnPlaceHolder() {
                if (this.program.settings['use-itin'])
                {
                    return `SSN or ITIN`
                } else {
                    return `Social Security Number`
                }
            },
            ssnLabel() {
                if (this.program.settings['use-itin'])
                {
                    return `SSN or ITIN` + (this.program.settings['require-applicant-social-security-number'] ? `<span > *</span>` : '');
                } else {
                    return `Social Security Number` + (this.program.settings['require-applicant-social-security-number'] ? `<span > *</span>` : '');
                }
            },
            changeQuestion() {
                if(this.changeQuestionId === null) {
                    return null;
                }

                return _.first(_.filter(this.program.prequalification_questions, q => q.number === this.changeQuestionId));
            },
            showForm() {
                return _.size(this.answers) === this.program.prequalification_questions.length;
            },
            ...mapState('Application', {
                applicantAddress: state => state.applicant.property_address,
            }),
            ...mapState('App', {
                env: state => state.env,
            }),
        },
        mounted() {

            this.$store.dispatch('Prequalification/setProgram', this.program);
            this.$store.dispatch('Prequalification/setGoogleApiKey', this.googleApiKey);

            this.modal = UIkit.modal('#pre-qualify-form-vue', {escClose: false, bgClose: false, keyboard: false,});
            this.noticeModal = UIkit.modal('#notice-modal', {escClose: false});
            this.declineModal = UIkit.modal('#not-qualified-vue', {escClose: false});

            jQuery('.open-prequalify').click(() => {
                this.noticeModal.show();
            })

            document.getElementById('pre-qualify-form-button').addEventListener('click', () => {
                this.noticeModal.show();
                // this.modal.show();
            })
        },
        methods: {
            async checkFieldPartnerId() {
                this.fieldPartnerLoading = true;
                this.errors = {};
                try {
                    let r = await axios.post('/api/check-field-partner', {pid: this.fieldPartnerId});
                    this.fieldPartnerLoading = false;
                    this.showFieldPartnerForm = false;
                    this.answers[this.currentQuestion] = 'Yes';
                    this.currentQuestion++;
                    // this.$toast.success('Field Partner ID Verified.')
                }catch(e) {
                    this.errors = e.response.data.errors;
                    this.fieldPartnerLoading = false;
                }
            },
            setUsingFieldPartner(usingFieldPartner) {
                this.usingFieldPartner = usingFieldPartner;
                if(!usingFieldPartner) {
                    this.showFieldPartnerForm = false;
                    this.answers[this.currentQuestion] = 'Not Using Field Partner';
                    this.currentQuestion++;
                }
            },
            reset() {
                this.form = {
                    hoh: {
                        index: 1,
                        first_name: '',
                        last_name: '',
                        email: '',
                        email_confirmation: '',
                        password: '',
                        password_confirmation: '',
                        phone: '',
                        phone_confirmation: '',
                        ssn: '',
                        ssn_confirmation: '',
                    }
                };
                this.formResponse = {};
                this.answers = {};
                this.verifiedAddress = null;
                this.currentQuestion = 1;
                this.showChangeModal = false;
                this.showDeclined = false;
            },
            showForApplication(application) {
                this.application = application;
                if(this.applicantAddress) {
                    this.$set(this, 'verifiedAddress', _.cloneDeep(this.applicantAddress));
                    EventBus.$emit('prequal.setVerifiedAddress', this.verifiedAddress);
                }
                this.modal.show({bgclose:false, escClose: false, keyboard: false});
            },
            showFormModal() {
                this.noticeModal.hide();
                this.modal.show();
            },
            addHouseholdMember() {
                this.householdMembers.push({
                    index: this.householdMembers.length + 2,
                    first_name: '',
                    last_name: '',
                    ssn: '',
                })
            },
            removeMember(index) {
                console.log('splicing at index ' + index);
                this.householdMembers.splice(index, 1);
            },
            answerQuestion(questionNumber, answer) {
                this.$set(this.answers, questionNumber, answer);
                this.changeQuestionId = null;
                this.showChangeModal = false;
                if(answer === 'no') {
                    this.showDeclined = true;
                    // this.modal.hide();
                    // this.noticeModal.hide();
                    // this.declineModal.show();
                }
                this.currentQuestion = questionNumber+1;
            },
            updateVerifiedAddress(address) {
                this.verifiedAddress = address;
            },
            editQuestion(questionNumber) {
                this.changeQuestionId = questionNumber;
                if(this.changeQuestion.type === 'income') {
                    this.verifiedAddress = null;
                }
                this.showChangeModal = true;
            },
            async submitForApplication() {
                this.errors = {};

                let data = {
                    password: this.form.hoh.password,
                    password_confirmation: this.form.hoh.password_confirmation,
                    ssn_confirmation: this.form.hoh.ssn_confirmation,
                    ssn: this.form.hoh.ssn,
                    prequal_answers: this.answers,
                    address: this.verifiedAddress,
                }

                try {
                    let r = await axios.post(`/api/hope/applications/${this.application.id}/prequal`, data);
                    await this.$store.dispatch('Application/fetch', this.application.id);
                    this.modal.hide();
                } catch(e) {
                    this.errors = e.response.data.errors;
                }
            },
            async submit() {
                this.errors = {};
                this.formResponse = {};


                if(_.size(this.errors) > 0) return;

                let hhData = [this.form.hoh];
                _.each(this.householdMembers, member => hhData.push(member));

                let prequalAnswers = this.answers;


                let data = {
                    email: this.form.hoh.email,
                    email_confirmation: this.form.hoh.email_confirmation,
                    phone_number: this.form.hoh.phone,
                    first_name: this.form.hoh.first_name,
                    last_name: this.form.hoh.last_name,
                    password: this.form.hoh.password,
                    password_confirmation: this.form.hoh.password_confirmation,
                    phone_confirmation: this.form.hoh.phone_confirmation,
                    ssn_confirmation: this.form.hoh.ssn_confirmation,
                    ssn: this.form.hoh.ssn,
                    prequal_answers: prequalAnswers,
                    hh_data: hhData,
                    program_id: this.program.slug,
                    address: this.verifiedAddress,
                    using_field_partner: this.usingFieldPartner ? 1 : 0,
                    field_partner_id: this.fieldPartnerId,
                }

                try {
                    let r = await axios.post('/api/register', data);
                    // return;
                    window.location = r.data.login_url;
                }catch(e) {
                    this.errors = e.response.data.errors;
                    this.formResponse = e.response.data;
                	if(this.formResponse.user_exists) {
                        UIkit.modal.confirm('<p class="uk-modal-body">It looks like you are already registered either by another family mmember, or your landlord. Please login to see your available applications.<br><br><a class="uk-button uk-button-primary" href="'+this.formResponse.login_url+'">Go to Login.</a></p>').dialog;
                    }
                }
            },

            async setDisqualified() {
                console.log('disqualifying');
                if(this.application) {
                    let r = await axios.post(`/api/hope/applications/${this.application.id}/set-disqualified`, {
                        prequal_answers: this.answers,
                    });
                    window.location = '/logout';
                }else {
                   this.cancel();
                }
            },

            cancel() {
                this.reset();
                this.modal.hide();
            },

            async checkForDuplicateEmailAddress(email, field) {
                this.errors = {};
                field = field || 'email';
                this.errors[field] = [];
                let data = {};
                data[field] = email;
                try {
                    let r = await axios.post('/api/check-email', data);
                }catch(e) {
                    this.errors = e.response.data.errors;
                    UIkit.modal.alert("It looks like your are already registered either by another family member or your landlord. Please login to see your available applications. <br/><br/> You can log into the portal <a href='/login'>Here</a>.")
                }

            },
            async checkForDuplicateSocialSecurityNumber(ssn, hhMemberId) {

                this.errors = {};
                let data = {}
                let field = 'ssn';
                if(hhMemberId === undefined) {
                    data['ssn'] = ssn;
                }else {
                    data['hh_data'] = {}
                    data['hh_data'][hhMemberId] = {ssn};
                    field = 'hh_data.'+hhMemberId+'.ssn';
                }

                this.errors[field] = [];

                try {
                    let r = await axios.post('/api/check-ssn', data);
                }catch(e) {
                    this.errors = e.response.data.errors;
                    UIkit.modal.alert("It looks like your are already registered either by another family member or your landlord. Please login to see your available applications. <br/><br/> You can log into the portal <a href='/login'>Here</a>.")
                }

            },

            getPasswordFieldMessage(field) {
                let val = this.form.hoh[field];
                if(val.length > 0 && val.length < 15) {
                    return 'Your password must be at least 15 characters.'
                }else if(field == 'password_confirmation' && this.form.hoh.password != this.form.hoh.password_confirmation) {
                    return 'Your password confirmation must match.';
                }
            },
        }
    }
</script>
